import React, { useEffect, useState } from "react";

import { AppLoader } from "../../../common/components/AppLoader";
import { useSprintFetch } from "../../data-access/useSprintFetch";
import { PublicAppConfig, PublicConfigurationContext } from "./PublicConfigurationContext";

type PublicConfigurationProviderProps = React.PropsWithChildren<unknown>;

export const PublicConfigurationProvider: React.FunctionComponent<PublicConfigurationProviderProps> = ({
    children
}: PublicConfigurationProviderProps) => {
    const [configuration, setConfiguration] = useState<PublicAppConfig>();
    const sprintFetch = useSprintFetch({ isPublic: true });

    useEffect(() => {
        sprintFetch
            .httpGet<PublicAppConfig>(`${process.env.PUBLIC_URL}/api/configuration/public`)
            .then((configJson) => {
                setConfiguration(configJson);
            });
    }, []);

    if (configuration) {
        return (
            <PublicConfigurationContext.Provider value={configuration}>{children}</PublicConfigurationContext.Provider>
        );
    }

    return <AppLoader message="Loading configuration..." />;
};
